export default {"src":"/_next/static/media/Vector-half-circle2.d0de4f91.svg","height":68,"width":140,"blurWidth":0,"blurHeight":0};